import { Routes } from '@angular/router';
import {MsalGuard} from '@azure/msal-angular';
import {UploadComponent} from './upload/upload.component';
import {AppComponent} from './app.component';

export const routes: Routes = [
  {
    path: '',
    canActivate: [MsalGuard],
    // component: AppComponent,
    component: UploadComponent,
  },
  // {
  //   path: 'login-failed',
  //   loadComponent: () => import('./auth/login-failed.component')
  //     .then(m => m.LoginFailedComponent),
  // },
  {
    path: '**',
    redirectTo: '',
  },
];
